import type { QueryClient } from '@tanstack/react-query';
import { LoginStatus } from '@/entities/user/user';
import { getErrorStatus } from '@/shared/api/intercepted-error';
import {
  getSessionState,
  requireAuthentication,
} from '@/entities/user/session';

export const handleUnauthorizedError = (
  error: unknown,
  queryClient: QueryClient,
) => {
  if (getErrorStatus(error) !== 401) return;
  const state = getSessionState(queryClient);
  if (![LoginStatus.login, LoginStatus.preparing].includes(state.loginStatus))
    return;

  requireAuthentication(queryClient);
};
